import { ChatFilter } from '../../../models/ChatFilter';

type UnreadState = Record<ChatFilter, Set<string>>;

const state: UnreadState = {
  [ChatFilter.PERSONAL]: new Set<string>(),
  [ChatFilter.MERCHANTS]: new Set<string>(),
  [ChatFilter.EVENTS]: new Set<string>(),
  [ChatFilter.GROUPS]: new Set<string>()
};

const listeners = new Set<() => void>();
let snapshotDirty = true;
let cachedSnapshot: ChatFilter[] = [];

const recomputeSnapshot = () => {
  cachedSnapshot = (Object.keys(state) as ChatFilter[]).filter((key) => state[key].size > 0);
  snapshotDirty = false;
};

const emit = () => {
  snapshotDirty = true;
  listeners.forEach((l) => l());
};

export const filtersUnreadStore = {
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  getSnapshot(): ChatFilter[] {
    if (snapshotDirty) {
      recomputeSnapshot();
    }
    return cachedSnapshot;
  },

  updateUnread(filter: ChatFilter | null, channelId: string, hasUnread: boolean) {
    if (filter === null) return;
    const set = state[filter];
    if (hasUnread) {
      if (!set.has(channelId)) {
        set.add(channelId);
        emit();
      }
    } else {
      if (set.delete(channelId)) {
        emit();
      }
    }
  },

  clear() {
    (Object.keys(state) as ChatFilter[]).forEach((key) => state[key].clear());
    emit();
  }
};

